export class CessionData {

  isCession: boolean;
  amount: number;
  bankId: string;

  constructor() {
    this.isCession = null;
  }
}

